/**
 * Browser-side twin of server/netInput.mjs.
 *
 * PlayerController only ever asks its input for `down`, `pressed` and
 * `mouse.dx/dy`. Feeding it a command instead of a keyboard is what lets the
 * client predict with the identical controller the server runs — and lets
 * reconciliation REPLAY old commands through it without touching real input
 * state.
 *
 * Deliberately a separate file from the server copy: the server module lives
 * outside src/ and importing it into the bundle would drag Node-only paths in.
 */
export class NetInput {
  constructor() {
    this.keys = new Set();
    this.edges = new Set();
    this.mouse = { dx: 0, dy: 0, left: false, right: false, leftEdge: false, rightEdge: false, wheel: 0 };
  }

  apply(cmd) {
    this.keys.clear();
    this.edges.clear();
    for (const k of cmd.keys ?? []) this.keys.add(k);
    for (const k of cmd.pressed ?? []) this.edges.add(k);
    this.mouse.dx = 0;
    this.mouse.dy = 0;
    this.mouse.left = !!cmd.fire;
    this.mouse.right = !!cmd.ads;
  }

  down(code) { return this.keys.has(code); }
  pressed(code) { return this.edges.has(code); }
  endFrame() { this.edges.clear(); }
}
